import client from './client';
import { EventManager, EventManagerPermissions, User } from '../types';

export interface TeamResponse {
  creator: Pick<User, '_id' | 'name' | 'email'> & { picture: string | null };
  managers: EventManager[];
}

export const eventTeamApi = {
  list: (eventId: string) =>
    client.get<TeamResponse>(`/events/${eventId}/team`).then((r) => r.data),

  add: (
    eventId: string,
    payload: { email: string; permissions?: Partial<EventManagerPermissions> },
  ) => client.post<EventManager>(`/events/${eventId}/team`, payload).then((r) => r.data),

  update: (
    eventId: string,
    managerId: string,
    permissions: Partial<EventManagerPermissions>,
  ) =>
    client
      .put<EventManager>(`/events/${eventId}/team/${managerId}`, { permissions })
      .then((r) => r.data),

  remove: (eventId: string, managerId: string) =>
    client.delete<void>(`/events/${eventId}/team/${managerId}`).then(() => undefined),
};

export const ALL_PERMISSIONS_FALSE: EventManagerPermissions = {
  allowEditingEventDetails: false,
  allowEndingEvent: false,
  allowDeletingEvent: false,
  allowCreatingNewAlbum: false,
  allowDeletingOfPhotos: false,
  allowAddingNewPresets: false,
  allowAddingNewFtpAccount: false,
  allowManagingTeam: false,
};

export const ALL_PERMISSIONS_TRUE: EventManagerPermissions = {
  allowEditingEventDetails: true,
  allowEndingEvent: true,
  allowDeletingEvent: true,
  allowCreatingNewAlbum: true,
  allowDeletingOfPhotos: true,
  allowAddingNewPresets: true,
  allowAddingNewFtpAccount: true,
  allowManagingTeam: true,
};

export const PERMISSION_LABELS: Record<keyof EventManagerPermissions, string> = {
  allowEditingEventDetails: 'Edit event name & description',
  allowEndingEvent: 'End the event',
  allowDeletingEvent: 'Delete the event',
  allowCreatingNewAlbum: 'Create new albums',
  allowDeletingOfPhotos: 'Delete photos',
  allowAddingNewPresets: 'Manage overlays & presets',
  allowAddingNewFtpAccount: 'Manage FTP accounts',
  allowManagingTeam: 'Manage team members',
};
